import type { Action, ThunkAction } from '@reduxjs/toolkit';
import { configureStore } from '@reduxjs/toolkit';
import { api } from './config/api';
import { customFiltersApi } from './config/CustomFiltersApi';
import { chartApi } from './config/chart-data';
import { currentSchemaApi } from './config/current-schema-api';
import { detailsWindowApi } from './config/details-window';
import { exportFileApi } from './config/export-api';
import { fieldTypesApi } from './config/field-types-api';
import { filtersApi } from './config/filters-api';
import { modulesApi } from './config/get-modules-api';
import { hierarchyFiltersApi } from './config/HierarchyFiltersApi';
import { hierarchyApi } from './config/hierarchy';
import { layoutApi } from './config/layout';
import { layoutWidgetApi } from './config/layout-widget';
import { metadataConfigApi } from './config/metadataConfig';
import { rolesApi } from './config/roles-api';
import { tableDataApi } from './config/table-data';
import { themeApi } from './config/theme';
import { usersApi } from './config/users-api';
import { viewsApi } from './config/views';
import { widgetConfigurationApi } from './config/widgetApi';
import { workFlowStepsApi } from './config/workflowStepsApi';
import rootReducer from './rootReducer';

export const store = configureStore({
  reducer: {
    [api.reducerPath]: api.reducer,
    [widgetConfigurationApi.reducerPath]: widgetConfigurationApi.reducer,
    [hierarchyApi.reducerPath]: hierarchyApi.reducer,
    [metadataConfigApi.reducerPath]: metadataConfigApi.reducer,
    [hierarchyFiltersApi.reducerPath]: hierarchyFiltersApi.reducer,
    [customFiltersApi.reducerPath]: customFiltersApi.reducer,
    [chartApi.reducerPath]: chartApi.reducer,
    [tableDataApi.reducerPath]: tableDataApi.reducer,
    [themeApi.reducerPath]: themeApi.reducer,
    [layoutApi.reducerPath]: layoutApi.reducer,
    [detailsWindowApi.reducerPath]: detailsWindowApi.reducer,
    [workFlowStepsApi.reducerPath]: workFlowStepsApi.reducer,
    [layoutWidgetApi.reducerPath]: layoutWidgetApi.reducer,
    [fieldTypesApi.reducerPath]: fieldTypesApi.reducer,
    [usersApi.reducerPath]: usersApi.reducer,
    [rolesApi.reducerPath]: rolesApi.reducer,
    [filtersApi.reducerPath]: filtersApi.reducer,
    [modulesApi.reducerPath]: modulesApi.reducer,
    [exportFileApi.reducerPath]: exportFileApi.reducer,
    [viewsApi.reducerPath]: viewsApi.reducer,
    [currentSchemaApi.reducerPath]: currentSchemaApi.reducer,
    rootReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(
      api.middleware,
      widgetConfigurationApi.middleware,
      hierarchyApi.middleware,
      metadataConfigApi.middleware,
      hierarchyFiltersApi.middleware,
      customFiltersApi.middleware,
      chartApi.middleware,
      tableDataApi.middleware,
      themeApi.middleware,
      layoutApi.middleware,
      detailsWindowApi.middleware,
      workFlowStepsApi.middleware,
      layoutWidgetApi.middleware,
      fieldTypesApi.middleware,
      usersApi.middleware,
      rolesApi.middleware,
      filtersApi.middleware,
      modulesApi.middleware,
      exportFileApi.middleware,
      viewsApi.middleware,
      currentSchemaApi.middleware
    ),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;
